
import { SocialPlatform } from '../profiles/types';

// Définition des plateformes disponibles
export const socialPlatforms: SocialPlatform[] = [
  {
    id: "facebook",
    platform: "facebook",
    name: "Facebook",
    description: "Pages",
    type: "social"
  }, 
  {
    id: "instagram",
    platform: "instagram",
    name: "Instagram",
    description: "Comptes professionnel",
    type: "social"
  }, 
  {
    id: "threads",
    platform: "threads",
    name: "Threads",
    description: "Comptes",
    type: "social"
  }, 
  {
    id: "twitter",
    platform: "twitter",
    name: "X (Twitter)",
    description: "Profils",
    type: "social"
  }, 
  {
    id: "linkedin",
    platform: "linkedin",
    name: "LinkedIn",
    description: "Profils, pages entreprise",
    type: "social"
  }, 
  {
    id: "tiktok",
    platform: "tiktok",
    name: "TikTok",
    description: "Comptes",
    type: "social"
  }, 
  {
    id: "youtube",
    platform: "youtube",
    name: "YouTube",
    description: "Chaînes",
    type: "social"
  }, 
  {
    id: "google-business",
    platform: "google-business",
    name: "Google Business",
    description: "Pages entreprise",
    type: "social"
  }, 
  {
    id: "pinterest",
    platform: "pinterest",
    name: "Pinterest",
    description: "Comptes",
    type: "social"
  }
];

export const adPlatforms: SocialPlatform[] = [
  {
    id: "meta-ads",
    platform: "meta",
    name: "Meta Ads",
    description: "Comptes publicitaires",
    type: "ad"
  }, 
  {
    id: "linkedin-ads",
    platform: "linkedin",
    name: "Publicités LinkedIn",
    description: "Comptes publicitaires",
    type: "ad"
  }, 
  {
    id: "tiktok-ads",
    platform: "tiktok",
    name: "TikTok Ads",
    description: "Comptes publicitaires",
    type: "ad"
  }
];
